// Reports made before `<Invalidation/>` installs the handler at boot are dropped. See docs/api-architecture.md#cache-tags.
let handler: ((tags: string[]) => void) | undefined

export function setInvalidationHandler(next: (tags: string[]) => void): () => void {
  handler = next

  return () => {
    if (handler === next) {
      handler = undefined
    }
  }
}

export function reportInvalidation(header: string | null): void {
  if (!header || !handler) {
    return
  }

  // `Headers.get()` joins several `xkey-invalidate` lines with ", " — a bare comma separator leaves a leading space on every key but the first.
  const tags = header.split(/\s*,\s*/).filter(Boolean)
  if (tags.length > 0) {
    handler(tags)
  }
}
